<template>
    <ve-ring 
      :data="materialChartData.materialChartData" 
      :settings='chartSettings' 
      height='480px' 
      width='480px' 
      :colors='chartColours'
      >
    </ve-ring>
</template>

<script>
  export default {
    props: {
      type: Object,
    },

    data () {
        this.chartSettings = {
            roseType: 'radius'
        }
        return {
          chartColours: ['#00a56b', '#007540', '#54d799', '#ffd95a','#f9a825', '#c17900'],
            // chartData: {
            // columns: ['material', 'kgCO2/m2'],
            // rows: [
            //     { 'material': 'Concrete 40MPa', 'kgCO2/m2': 165.6 },
            //     { 'material': 'Concrete 50MPa', 'kgCO2/m2': 16.5 },
            //     { 'material': 'Steel Reinforcement', 'kgCO2/m2': 91.0 },
            // ]
          // }
        }
    },

    computed:{
      materialTable() {
        return this.type.materials;
      },

      materialChartData() {
        const data = [];
        const columns = ['name', 'kgCO2pm2'];

        for (var i = 0; i < this.materialTable.length; ++i) {
          let typ = this.materialTable[i];

          data.push({
          name: typ.name,
          kgCO2pm2: Number.parseFloat(typ.value.toFixed(1))
          })
        }

        return {
            materialChartData: { columns: columns, rows: data }
        };
    }
  }
}
</script>